var _circle, _rect, _rect2, _rect3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarjapretaGenerico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 5,
    width: 16,
    height: 22,
    rx: 3,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 7,
    y: 10,
    width: 18,
    height: 8,
    fill: "#FFDE49"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 7,
    y: 18,
    width: 18,
    height: 4,
    fill: "#16002C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5275 13.5761H15.6847V14.7488H17.4143C17.1404 15.3337 16.5605 15.6813 16 15.6813C15.2302 15.6813 14.4237 15.0256 14.4237 14C14.4237 12.9744 15.2302 12.3187 16 12.3187C16.4788 12.3187 16.9718 12.5724 17.2761 13.011H18.8332C18.4244 11.8401 17.3103 11 16 11C14.3431 11 13 12.3431 13 14C13 15.6569 14.3431 17 16 17C17.6569 17 19 15.6569 19 14C19 13.8561 18.9899 13.7146 18.9703 13.5761H18.7661H17.5275Z",
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 10C6.5 6.41015 9.41015 3.5 13 3.5H19C22.5899 3.5 25.5 6.41015 25.5 10V22C25.5 25.5898 22.5899 28.5 19 28.5H13C9.41015 28.5 6.5 25.5899 6.5 22V10ZM13 6.5C11.067 6.5 9.5 8.067 9.5 10V22C9.5 23.933 11.067 25.5 13 25.5H19C20.933 25.5 22.5 23.933 22.5 22V10C22.5 8.067 20.933 6.5 19 6.5H13Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarjapretaGenerico);
export default __webpack_public_path__ + "static/media/tarjapreta_generico.f2336fcbd45b134fe7a15632e069c216.svg";
export { ForwardRef as ReactComponent };